import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoAlertaGrupoCondicion } from '../_models/producto-alerta-grupo-condicion';

@Injectable({
  providedIn: 'root'
})
export class ProductoAlertaGrupoCondicionService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosAlertasGruposCondiciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoAlertaGrupoCondicion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoAlertaGrupoCondicion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoAlertaGrupoCondicion ) );
  }

  crear( regCrear: ProductoAlertaGrupoCondicion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoAlertaGrupoCondicion ) );
  }

  crearBulk( condiciones: ProductoAlertaGrupoCondicion[] ) {
    //regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio + '/bulk', condiciones ).pipe( map( res => res as ProductoAlertaGrupoCondicion[] ) );
  }

  actualizar( regActualizar: ProductoAlertaGrupoCondicion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
